import columns from '../../../../react-table/helpers/columns';

export default (data) => {
  const {
    FilteredTextColumn,
    FilteredNonZeroNumberColumn,
    FilteredDateTimeColumn,
  } = columns(data);

  return [
    {
      Header: '',
      columns: [
        new FilteredNonZeroNumberColumn('Transaction id', 'id').withShow(false),
        new FilteredTextColumn('Repat from Operator', 'operatorFrom'),
        new FilteredTextColumn('Repat from IMPC', 'impcFrom'),
        new FilteredTextColumn('Repat to Operator', 'operatorTo'),
        new FilteredTextColumn('Repat to IMPC', 'impcTo'),
        new FilteredNonZeroNumberColumn('Quantity', 'quantity'),
        new FilteredNonZeroNumberColumn('Objected Quantity', 'quantityObjected'),
        new FilteredNonZeroNumberColumn('Confirmed Quantity', 'quantityConfirmed'),
        new FilteredDateTimeColumn('Departure Date and time', 'departureDateTime').withWidth(135),
        new FilteredDateTimeColumn('Arrival Date and time', 'arrivalDateTime').withWidth(135),
        new FilteredTextColumn('User', 'lastUpdateUser'),
        new FilteredDateTimeColumn('Last action occurrence', 'lastUpdateDate').withWidth(135),
        new FilteredTextColumn('Comments', 'comments'),
        new FilteredTextColumn('Status', 'status'),
      ],
    },
  ];
};
